// arca-strategies.service.ts
import { Injectable } from "@angular/core";
import { BilledRequestStrategy } from "services/billed-resquest/billed-request-strategy.interface";
import { BilledRequestService } from "services/billed-resquest/billed-request.service";
import { ArcaService } from "services/billed-resquest/services/tax-authorities/argentina/arca.service";

@Injectable()
export class ArcaStrategies implements BilledRequestStrategy {
  constructor(
    private billedRequestService: BilledRequestService,
    private arcaService: ArcaService
  ) {}

  async initialize(config: any): Promise<boolean> {
    try {
      console.log('Initializing ARCA strategies...');

      // Inicializar datos de ARCA
      await this.arcaService.initializeArcaData();

      // Aquí puedes inicializar otros servicios si es necesario
      // await this.paymentApiService.initialize();

      console.log('ARCA strategies initialized successfully');
      return true;
    } catch (error) {
      console.error('Failed to initialize ARCA strategies:', error);
      return false;
    }
  }

  async processBilled(metadata: any): Promise<any> {
    try {
      // Verificar que los datos estén cargados
      if (!this.arcaService.isDataInitialized()) {
        await this.arcaService.initializeArcaData();
      }

      // Procesar la facturación usando datos de ARCA
      const arcaData = this.arcaService.getArcaData();

      // Aquí va la lógica específica de procesamiento con ARCA
      const result = await this.processWithArcaData(metadata, arcaData);

      return {
        success: true,
        data: result,
        arcaDataLoaded: true
      };
    } catch (error) {
      console.error('Error processing billed with ARCA:', error);
      return {
        success: false,
        error: error.message,
        arcaDataLoaded: this.arcaService.isDataInitialized()
      };
    }
  }

  private async processWithArcaData(metadata: any, arcaData: any): Promise<any> {
    // Implementa la lógica específica de procesamiento con ARCA
    // Usa los datos cargados de arcaData

    // Ejemplo:
    const ivaTypes = arcaData.ivaTypes || [];
    const receiptTypes = arcaData.receiptTypes || [];

    // Tu lógica de facturación aquí...
    return {
      processed: true,
      timestamp: new Date(),
      metadata,
      arcaDataAvailable: true
    };
  }

  // Métodos adicionales específicos de ARCA
  async getArcaCatalog(catalogName: string): Promise<any> {
    if (!this.arcaService.isDataInitialized()) {
      await this.arcaService.initializeArcaData();
    }

    const arcaData = this.arcaService.getArcaData();
    return arcaData[catalogName] || [];
  }

  async validateArcaData(): Promise<{ isValid: boolean; missingData: string[] }> {
    const requiredCatalogs = [
      'ivaConditions',
      'currencies',
      'ivaTypes',
      'documentTypes',
      'receiptTypes'
    ];

    const missingData: string[] = [];

    if (!this.arcaService.isDataInitialized()) {
      return { isValid: false, missingData: ['ARCA data not initialized'] };
    }

    const arcaData = this.arcaService.getArcaData();

    requiredCatalogs.forEach(catalog => {
      if (!arcaData[catalog] || arcaData[catalog].length === 0) {
        missingData.push(catalog);
      }
    });

    return {
      isValid: missingData.length === 0,
      missingData
    };
  }
}
